/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import { Page, View, Text, Image, Document } from '@react-pdf/renderer';
// utils
import { fCurrency } from '../../../../utils/formatNumber';
//
import styles from './InvioceStyle';

// ----------------------------------------------------------------------

InvoicePDF.propTypes = {
  invoice: PropTypes.object.isRequired,
};

export default function InvoicePDF({ invoice }) {
  // eslint-disable-next-line camelcase
  const {
    plan_status,
    cable_plan,
    iuc,
    customer_name,
    cable_name,
    transid,
    my_trans_id,
    system,
    charges,
    plan_date,
    amount,
    oldbal,
    newbal,
  } = invoice;

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={[styles.gridContainer, styles.mb40]}>
          <Image source="/upload/welcome.png" style={{ height: 32 }} />
          <View style={{ alignItems: 'flex-end', flexDirection: 'column' }}>
            <Text style={styles.h3}>
              {(plan_status === 1 && 'successful') ||
                (plan_status === 0 && 'proccessing') ||
                (plan_status === 2 && 'failed')}
            </Text>
            <Text>{my_trans_id}</Text>
          </View>
        </View>

        <Text style={[styles.overline, styles.mb8]}> Cable Subscription Invoice Details</Text>

        <View style={styles.table}>
          <View style={styles.tableRow}>
            <View style={styles.tableCell_2}>
              <Text style={styles.subtitle2}>Cable Name</Text>
            </View>
            <Text>{cable_name}</Text>
          </View>
          <View style={styles.tableRow}>
            <View style={styles.tableCell_2}>
              <Text style={styles.subtitle2}>Cable Plan</Text>
            </View>
            <Text>{cable_plan}</Text>
          </View>
          <View style={styles.tableRow}>
            <View style={styles.tableCell_2}>
              <Text style={styles.subtitle2}>Iuc Number</Text>
            </View>
            <Text>{iuc}</Text>
          </View>
          <View style={styles.tableRow}>
            <View style={styles.tableCell_2}>
              <Text style={styles.subtitle2}>Customer Name</Text>
            </View>
            <Text>{customer_name}</Text>
          </View>
          <View style={styles.tableRow}>
            <View style={styles.tableCell_2}>
              <Text style={styles.subtitle2}>Amount</Text>
            </View>
            <Text>₦{fCurrency(amount)}</Text>
          </View>
          <View style={styles.tableRow}>
            <View style={styles.tableCell_2}>
              <Text style={styles.subtitle2}>Charges</Text>
            </View>
            <Text>₦{fCurrency(charges)}</Text>
          </View>
          <View style={styles.tableRow}>
            <View style={styles.tableCell_2}>
              <Text style={styles.subtitle2}>Old Balance</Text>
            </View>
            <Text>₦{fCurrency(oldbal)}</Text>
          </View>
          <View style={styles.tableRow}>
            <View style={styles.tableCell_2}>
              <Text style={styles.subtitle2}>New Balance</Text>
            </View>
            <Text>₦{fCurrency(newbal)}</Text>
          </View>
          <View style={styles.tableRow}>
            <View style={styles.tableCell_2}>
              <Text style={styles.subtitle2}>Client Reference ID</Text>
            </View>
            <Text>{transid}</Text>
          </View>
          <View style={styles.tableRow}>
            <View style={styles.tableCell_2}>
              <Text style={styles.subtitle2}>System</Text>
            </View>
            <Text>{system}</Text>
          </View>
          <View style={styles.tableRow}>
            <View style={styles.tableCell_2}>
              <Text style={styles.subtitle2}>Date</Text>
            </View>
            <Text>{plan_date}</Text>
          </View>
        </View>

        <View style={[styles.gridContainer, styles.footer]}>
          <View style={styles.col8}>
            <Text style={styles.subtitle2}>NOTES</Text>
            <Text> We appreciate your continuous patronage. Your satisfaction is our top priority!</Text>
          </View>
          {/* <View style={[styles.col4, styles.alignRight]}>
            <Text style={styles.subtitle2}>any enquiry, kindly contact us @</Text>
          </View> */}
        </View>
      </Page>
    </Document>
  );
}
